// extracted by mini-css-extract-plugin
export var browseMoreNav = "blog-post-preview-grid-module--browseMoreNav--awpLJ";
export var grid = "blog-post-preview-grid-module--grid--RhEbL";
export var grid_four = "blog-post-preview-grid-module--grid_four--Ygg+4";
export var grid_two = "blog-post-preview-grid-module--grid_two--+ZA1e";
export var headline = "blog-post-preview-grid-module--headline--Id-Os";
export var root = "blog-post-preview-grid-module--root--3HCha";